module.exports = __webpack_public_path__ + "static/media/dots.1b61f349.svg";